import styled from "styled-components";

import { getToneTokens } from "../../../styles/shared";

// ---------- Barra de controles ----------

// Cabeçalho compacto: título + abas na MESMA linha (o card alto do
// EntityHeader + abas separadas comiam ~130px — pedido da gestora
// 2026-07-07 de compactar o topo da página).
export const HeaderCompacto = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;

  h1 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.02em;
    color: var(--ink);
  }
`;

// KPIs compactos em texto (substituem o KpiStrip de cards altos):
// clicáveis — aplicam o filtro de situação correspondente.
export const StatsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px 14px;
  flex-wrap: wrap;
  font-size: 12.5px;
  color: var(--ink-2);
`;

export const StatChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: none;
  background: transparent;
  padding: 2px 0;
  font-size: 12.5px;
  color: ${({ $active }) => ($active ? "var(--accent)" : "var(--ink-2)")};
  cursor: pointer;

  strong {
    font-size: 14px;
    color: ${({ $active }) => ($active ? "var(--accent)" : "var(--ink)")};
    font-variant-numeric: tabular-nums;
  }

  &:hover { color: var(--accent); }
  &:hover strong { color: var(--accent); }
`;

export const SepVert = styled.span`
  width: 1px;
  height: 20px;
  background: var(--border);
  flex: none;
`;

export const ControlesBar = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;

  .search {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 180px;
    max-width: 340px;
    padding: 0 10px;
    height: 30px;
    border: 1px solid var(--border);
    border-radius: 8px;
    background: var(--surface);
    color: var(--ink-2);
  }
  .search input {
    border: none;
    background: none;
    height: 100%;
    flex: 1;
    color: var(--ink);
    font-size: 13px;
    outline: none;
  }
`;

export const ChipsRow = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
`;

export const ChipsLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ink-2);
  margin-right: 2px;
`;

export const Chip = styled.button`
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid ${({ $active }) => ($active ? "var(--accent)" : "var(--border)")};
  background: ${({ $active }) => ($active ? "var(--accent-soft)" : "var(--surface)")};
  color: ${({ $active }) => ($active ? "var(--accent)" : "var(--ink-2)")};
  &:hover { border-color: var(--accent); color: var(--accent); }
`;

// ---------- Botão "Filtrar" + popover de filtros ----------

export const FiltroWrap = styled.div`
  position: relative;
  flex: none;
`;

export const FiltroBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid ${({ $ativo }) => ($ativo ? "var(--accent)" : "var(--border)")};
  background: ${({ $ativo }) => ($ativo ? "var(--accent-soft)" : "var(--surface)")};
  color: ${({ $ativo }) => ($ativo ? "var(--accent)" : "var(--ink-2)")};
  &:hover { border-color: var(--accent); color: var(--accent); }
`;

export const FiltroBadge = styled.span`
  display: inline-grid;
  place-items: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--accent);
  color: var(--ink-on-accent);
  font-size: 10px;
  font-weight: 700;
`;

export const FiltroDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 60;
  min-width: 280px;
  max-width: min(92vw, 360px);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: var(--bg-elevated, var(--surface));
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
`;

export const FiltroGrupo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ViewToggle = styled.div`
  margin-left: auto;
  display: inline-flex;
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
`;

export const ToggleBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border: none;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background: ${({ $active }) => ($active ? "var(--accent-soft)" : "var(--surface)")};
  color: ${({ $active }) => ($active ? "var(--accent)" : "var(--ink-2)")};
  & + & { border-left: 1px solid var(--border); }
`;

// ---------- Elementos comuns ----------

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 999px;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ $tone }) => {
    const t = getToneTokens(null, $tone || "neutral");
    return `background:${t.background}; color:${t.text}; border:1px solid ${t.border};`;
  }}
`;

// Etiqueta "LOTE {numero}" nas solicitações cujas peças já entraram num
// lote de corte (pedido da gestora 2026-07-07). Cor info (accent) porque
// comunica um estado — não decoração.
export const LoteTag = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 2px 7px;
  border-radius: 6px;
  background: var(--accent-soft);
  color: var(--accent);
  border: 1px solid var(--accent);
  white-space: nowrap;
`;

export const LotesWrap = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
`;

// ---------- Carrossel de peças (visual da fita no detalhe) ----------

export const CarrosselWrap = styled.div`
  position: relative; /* ancora do SeletorVisao (2D/3D) */
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface);
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/**
 * Seletor 2D/3D no canto superior esquerdo do preview da peca.
 * Padrao 2D; o 3D e opt-in e carrega o three.js sob demanda.
 */
export const SeletorVisao = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;
  display: inline-flex;
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
  background: var(--surface);

  button {
    border: none;
    background: transparent;
    color: var(--ink-2);
    font: inherit;
    font-size: 11px;
    font-weight: 700;
    padding: 5px 10px;
    cursor: pointer;
  }
  button[data-on="true"] {
    background: var(--accent-soft);
    color: var(--accent);
  }
`;

export const CarrosselPalco = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CarrosselNavBtn = styled.button`
  flex: none;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--ink);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover:not(:disabled) { background: var(--accent-soft); border-color: var(--accent); }
  &:disabled { opacity: 0.4; cursor: default; }
`;

// Viewport que recorta o trilho; o trilho desliza na horizontal (translateX)
// ao trocar de peça. Respeita o toggle global de animações do ERP
// (data-animacoes="off") e prefers-reduced-motion.
export const CarrosselViewport = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

// Classe ESTÁVEL (transição fixa); o transform vem inline via style prop
// (translateX(-idx*100%)) — evita a classe-por-índice do styled-components,
// que engasgava a transição na troca de classe. Padrão canônico de
// carrossel: inline transform + transição na classe.
export const CarrosselTrack = styled.div`
  display: flex;
  transition: transform 0.32s cubic-bezier(0.16, 1, 0.3, 1);

  [data-animacoes="off"] & { transition: none; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;

export const CarrosselSlideItem = styled.div`
  flex: 0 0 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 2px;
`;

export const CarrosselCaption = styled.div`
  text-align: center;
  font-size: 12.5px;
  color: var(--ink);

  .titulo { font-weight: 600; }
  .fita { color: var(--accent); font-weight: 600; }
  .sem { color: var(--ink-2); }
`;

export const CarrosselDots = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
`;

export const CarrosselDot = styled.button`
  width: ${({ $ativo }) => ($ativo ? "20px" : "8px")};
  height: 8px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  padding: 0;
  background: ${({ $ativo }) => ($ativo ? "var(--accent)" : "var(--border-strong, var(--border))")};
  transition: width 0.15s ease;
`;

export const EmptyMsg = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: var(--ink-2);
  font-size: 14px;
  border: 1px dashed var(--border);
  border-radius: 12px;
`;

export const ErrorMsg = styled.div`
  padding: 12px 16px;
  border-radius: 10px;
  background: var(--danger-bg);
  color: var(--danger-text);
  border: 1px solid var(--danger-border);
  font-size: 13px;
`;

export const NeutralBanner = styled.div`
  padding: 12px 16px;
  border-radius: 10px;
  background: var(--surface);
  color: var(--ink-2);
  border: 1px solid var(--border);
  font-size: 13px;
`;

// Aviso que pede decisão (ex.: perda na produção ao cancelar).
export const WarningBanner = styled.div`
  padding: 12px 16px;
  border-radius: 10px;
  color: var(--warning-text);
  border: 1px solid var(--warning-border, var(--warning-text));
  background: var(--warning-bg);
  font-size: 13px;
`;

/**
 * Botão "Imprimir imagens" do topo do detalhe.
 *
 * Fica visível MESMO sem foto (desabilitado, com tooltip) de propósito: se o
 * botão sumisse, o usuário ficaria procurando onde imprime — desabilitado ele
 * já responde a pergunta ("esta solicitação não tem imagem") sem clique.
 */
export const BtnImagens = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  height: 38px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--ink);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) { background: var(--accent-soft); }

  /* Desabilitado precisa PARECER desabilitado: sem hover, sem cursor de mão e
     com contraste baixo — o operador lê "não dá" antes de tentar clicar. */
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    color: var(--ink-2);
  }

  .qtd { font-weight: 500; opacity: 0.72; }
`;

export const GhostBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--ink);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  &:hover { background: var(--accent-soft); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const DangerGhostBtn = styled(GhostBtn)`
  color: var(--danger-text);
  border-color: var(--danger-border);
  &:hover { background: var(--danger-bg); }
`;

export const PrimaryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: var(--accent);
  color: var(--ink-on-accent);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  &:hover { filter: brightness(0.96); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const InlineError = styled.div`
  font-size: 11px;
  color: var(--danger-text);
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: var(--ink-2);
`;

export const Input = styled.input`
  height: 38px;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  color: var(--ink);
  font-size: 13px;
  box-sizing: border-box;
  &::placeholder { color: var(--ink-2); }
  &:focus { outline: none; border-color: var(--accent); }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 70px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  color: var(--ink);
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
  &:focus { outline: none; border-color: var(--accent); }
`;

export const RowEnd = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
`;

export { default as Checkbox } from "../../../components/Checkbox";

// ---------- Tabela ----------

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 13px;
`;

export const Th = styled.th`
  /* relative: ancora o ResizeHandle (alca de arrasto) na borda direita */
  position: relative;
  text-align: left;
  padding: 11px 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ink-2);
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  /* Celula do checkbox de selecao: sem ellipsis (o "…" aparecia ao lado
     do checkbox quando a coluna era estreita). */
  ${({ $sel }) => ($sel ? `
    overflow: visible;
    text-overflow: clip;
    text-align: center;
    padding: 11px 4px;
  ` : "")}
`;

export const Td = styled.td`
  padding: 10px 12px;
  color: var(--ink);
  border-bottom: 1px solid var(--border);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &.mono { font-variant-numeric: tabular-nums; color: var(--ink-2); }

  ${({ $sel }) => ($sel ? `
    overflow: visible;
    text-overflow: clip;
    text-align: center;
    padding: 10px 4px;
  ` : "")}
`;

export const Tr = styled.tr`
  cursor: pointer;
  transition: background 0.12s ease;
  &:hover { background: var(--accent-soft); }
  &:last-child td { border-bottom: none; }
`;

export const DesktopOnly = styled.div`
  @media (max-width: 767px) { display: none; }
`;

export const MobileOnly = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export const SolCard = styled.div`
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
`;

export const SolCardHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  strong {
    font-variant-numeric: tabular-nums;
    color: var(--ink);
    font-size: 13px;
  }
  > span:last-child { margin-left: auto; }
`;

export const SolCardMeta = styled.div`
  font-size: 12px;
  color: var(--ink-2);
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
`;

// ---------- Barra sticky de lote ----------

export const StickyBar = styled.div`
  position: sticky;
  bottom: 12px;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--surface);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
`;

export const StickyInfo = styled.div`
  font-size: 13px;
  color: var(--ink);
  font-weight: 600;
`;

export const StickyWarn = styled.div`
  font-size: 12px;
  color: var(--warning-text);
  background: var(--warning-bg);
  border: 1px solid var(--warning-border);
  border-radius: 8px;
  padding: 6px 10px;
`;

export const StickyActions = styled.div`
  margin-left: auto;
  display: flex;
  gap: 8px;
  align-items: center;
`;

// ---------- Kanban (lanes LATERAIS — scroll horizontal só no board) ----------

export const Board = styled.div`
  display: flex;
  gap: 12px;
  align-items: stretch;
  overflow-x: auto;
  /* A tela principal não rola na vista kanban: o board ocupa a altura
     restante da viewport (medida via ref no Kanban.jsx) e o scroll
     vertical acontece SÓ dentro de cada lane. */
  overflow-y: hidden;
  padding-bottom: 4px;
`;

export const Lane = styled.div`
  /* Cresce para preencher a largura total do board (tela cheia); trava em
     min-width para virar scroll horizontal lateral quando houver colunas
     demais. Antes era 0 0 280px (largura fixa, sobrava margem na tela larga). */
  flex: 1 1 280px;
  min-width: 280px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface);
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const LaneHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
`;

export const LaneTitle = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ink-2);
`;

export const LaneCount = styled.span`
  margin-left: auto;
  font-size: 11px;
  font-weight: 600;
  color: var(--accent);
  background: var(--accent-soft);
  padding: 2px 8px;
  border-radius: 999px;
`;

export const LaneBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;

export const KCard = styled.div`
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  cursor: pointer;
  &:hover { border-color: var(--accent); }
  &[data-selecionado] {
    border-color: var(--accent);
    box-shadow: 0 0 0 1px var(--accent);
  }
  /* Caixa de seleção: recolhida até o hover/foco do card; marcada, fica. */
  .ksel {
    display: inline-flex;
    width: 0;
    opacity: 0;
    overflow: hidden;
    transition: width .14s ease, opacity .14s ease;
  }
  &:hover .ksel,
  &:focus-within .ksel,
  .ksel[data-on] {
    width: 18px;
    opacity: 1;
    overflow: visible;
  }
  @media (hover: none) {
    .ksel { width: 18px; opacity: 1; overflow: visible; }
  }
`;

export const KCardTop = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  strong {
    font-size: 12px;
    font-variant-numeric: tabular-nums;
    color: var(--ink);
  }
  > span:last-child { margin-left: auto; }
`;

export const KCardCliente = styled.div`
  font-size: 13px;
  color: var(--ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/* Linha "quem solicitou · data/hora" sob o cliente. flex-wrap permite a
   quebra ENTRE o nome e a data/hora (cada um em seu span nowrap) quando
   faltar largura no card estreito. */
export const KCardSolicitante = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 6px;
  margin-top: 2px;
  font-size: 11px;
  color: var(--ink-3);

  .quem {
    color: var(--ink-2);
    font-weight: 500;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }
  .quando {
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
`;

export const KCardMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: var(--ink-2);
`;

export const LaneEmpty = styled.div`
  padding: 18px 10px;
  text-align: center;
  font-size: 12px;
  color: var(--ink-2);
`;

// ---------- Detalhe (SlideOverPanel) ----------

export const DetailTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
  @media (max-width: 520px) { grid-template-columns: 1fr; }
`;

export const DetailItem = styled.div`
  min-width: 0;
  .lbl {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--ink-2);
  }
  .val {
    font-size: 13px;
    color: var(--ink);
    overflow-wrap: anywhere;
  }
`;

export const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 18px;
`;

export const PecaCard = styled.div`
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PecaHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  strong {
    font-size: 13px;
    color: var(--ink);
    font-variant-numeric: tabular-nums;
  }
`;

export const PecaLinha = styled.div`
  font-size: 12px;
  color: var(--ink-2);
  overflow-wrap: anywhere;
  span.forte { color: var(--ink); font-weight: 600; }
`;

export const FitaWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--ink-2);
  flex-wrap: wrap;
`;

export const FitaDot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 18px;
  padding: 0 4px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  border: 1px solid ${({ $on }) => ($on ? "var(--accent)" : "var(--border)")};
  background: ${({ $on }) => ($on ? "var(--accent-soft)" : "transparent")};
  color: ${({ $on }) => ($on ? "var(--accent)" : "var(--ink-2)")};
`;

export const FotosRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const FotoThumb = styled.img`
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid var(--border);
  cursor: zoom-in;
`;

export const Timeline = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const TimelineItem = styled.li`
  position: relative;
  padding: 0 0 14px 22px;
  &::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 5px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $tone }) => getToneTokens(null, $tone || "neutral").accent || "var(--accent)"};
  }
  &:not(:last-child)::after {
    content: "";
    position: absolute;
    left: 8px;
    top: 16px;
    bottom: 0;
    width: 1px;
    background: var(--border);
  }
  .titulo { font-size: 13px; font-weight: 600; color: var(--ink); }
  .meta { font-size: 12px; color: var(--ink-2); overflow-wrap: anywhere; }
`;

export const MotivoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

// ---------- Modal Gerar lote ----------

export const LoteFormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  @media (max-width: 560px) { grid-template-columns: 1fr; }
`;

export const PecaRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid ${({ $on }) => ($on ? "var(--accent)" : "var(--border)")};
  border-radius: 10px;
  background: ${({ $on }) => ($on ? "var(--accent-soft)" : "var(--surface)")};
  cursor: pointer;
`;

export const PecaRowMain = styled.div`
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  .linha1 {
    font-size: 13px;
    color: var(--ink);
    font-weight: 600;
    overflow-wrap: anywhere;
  }
  .linha2 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 10px;
    font-size: 12px;
    color: var(--ink-2);
  }
`;

export const ListaHeadRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 600;
  color: var(--ink-2);
`;

/* ---------- Comprovantes do lote (baixar/imprimir) ---------- */

export const Select = styled.select`
  height: 34px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  color: var(--ink);
  font-size: 13px;

  &:focus {
    outline: none;
    border-color: var(--accent);
  }
`;

export const CompLoteGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
  margin-top: 10px;
`;

export const CompLoteThumb = styled.button`
  position: relative;
  border: 2px solid ${({ $on }) => ($on ? "var(--accent)" : "var(--border)")};
  border-radius: 10px;
  background: var(--surface);
  padding: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;

  &:disabled {
    cursor: default;
    opacity: 0.8;
  }
  img {
    width: 100%;
    border-radius: 6px;
    display: block;
  }
  .ph {
    height: 170px;
    display: grid;
    place-items: center;
    color: var(--ink-3);
    font-size: 12px;
    background: var(--surface-hover, var(--bg));
    border-radius: 6px;
  }
  .num {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: var(--ink);
  }
`;

/* ---------- Barra de filtros (padrão Excel) ----------
   Promovida a components/FiltroExcel (o Cadastro de Suprimentos usa a
   mesma). Reexportada aqui para os imports desta pasta continuarem. */
export {
  FexBadge, FexBar, FexBtn, FexChip, FexChipsRow, FexCount, FexFooter,
  FexLista, FexOpcao, FexPanel, FexSearch, FexVazio, FexWrap,
} from "../../../components/FiltroExcel/styles";
